"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingConfetti = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
require("./onboarding-confetti.scss");
/** number of pieces launched out of each bottom corner */
const PIECES_PER_CORNER = 16;
/** how many `.color-N` variants onboarding-confetti.scss defines */
const COLOR_COUNT = 4;
const MIN_DURATION_MS = 1600;
const MAX_DURATION_MS = 2400;
const MAX_DELAY_MS = 320;
/** the moment the slowest piece can still be in the air — after this the overlay unmounts */
const FLIGHT_MS = MAX_DURATION_MS + MAX_DELAY_MS;
const CORNERS = ['left', 'right'];
const randomBetween = (min, max) => min + Math.random() * (max - min);
const buildPieces = () => Array.from({ length: PIECES_PER_CORNER }, () => ({
    dx: randomBetween(120, 640),
    // negative: the screen's y axis points down and the pieces go up
    dy: -randomBetween(220, 680),
    rotation: randomBetween(180, 720),
    delayMs: randomBetween(0, MAX_DELAY_MS),
    durationMs: randomBetween(MIN_DURATION_MS, MAX_DURATION_MS),
    colorIndex: Math.floor(Math.random() * COLOR_COUNT),
}));
/**
 * Two bursts of paper out of the bottom corners of the screen, for the moment a checklist
 * step gets ticked off. Purely decorative, hence `aria-hidden` and `pointer-events: none`.
 *
 * Rendered into `document.body` rather than inside the toast: react-hot-toast animates its
 * toasts with a `transform`, and a transformed ancestor is what `position: fixed` resolves
 * against — inside the toast the overlay would be pinned to the toast instead of to the
 * viewport. Unmounts itself once the last piece has landed, so nothing is left behind
 * for the rest of the toast's life.
 */
const OnboardingConfetti = () => {
    const [isFlying, setIsFlying] = react_1.default.useState(true);
    // built once: re-rolling the randoms on a re-render would restart every piece mid-flight
    const pieces = react_1.default.useMemo(() => CORNERS.map(() => buildPieces()), []);
    react_1.default.useEffect(() => {
        const timer = window.setTimeout(() => setIsFlying(false), FLIGHT_MS);
        return () => window.clearTimeout(timer);
    }, []);
    if (!isFlying)
        return null;
    return (0, react_dom_1.createPortal)(react_1.default.createElement("div", { className: 'onboarding-confetti', "data-testid": 'onboarding-confetti', "aria-hidden": true }, CORNERS.map((corner, cornerIndex) => (react_1.default.createElement("div", { key: corner, className: (0, classnames_1.default)('onboarding-confetti-corner', corner) }, pieces[cornerIndex].map((piece, index) => (react_1.default.createElement("span", { key: index, className: (0, classnames_1.default)('onboarding-confetti-piece', `color-${piece.colorIndex}`), style: {
            '--dx': `${piece.dx}px`,
            '--dy': `${piece.dy}px`,
            '--rot': `${piece.rotation}deg`,
            '--delay': `${piece.delayMs}ms`,
            '--duration': `${piece.durationMs}ms`,
        } }))))))), document.body);
};
exports.OnboardingConfetti = OnboardingConfetti;
exports.default = exports.OnboardingConfetti;
